import { render, staticRenderFns } from "./ieAlertModal.vue?vue&type=template&id=12d256f5&"
import script from "./ieAlertModal.vue?vue&type=script&lang=ts&"
export * from "./ieAlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./ieAlertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports